// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__x6C8a","cardTitle":"ActiveCustomers_cardTitle__5AbhQ","chart":"ActiveCustomers_chart__SOX5y"};